import { render } from "./DashboardSeller.vue?vue&type=template&id=498113a8"
import script from "./DashboardSeller.vue?vue&type=script&lang=js"
export * from "./DashboardSeller.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__